export class Organization {
  constructor(public id: number, public organizationName: string) { }
}
